import React from "react";

import { LabelsStateKey, PasswordValidatorLabels } from "./labels";

import styles from "./PasswordValidationLabels.module.scss";

type PasswordValidationLabelsType = {
  validPassword: Record<LabelsStateKey, boolean>;
  passwordHasError: boolean;
  passwordIsValid: boolean;
  passwordValidatorLabels: PasswordValidatorLabels;
};

const PasswordValidationLabels: React.FC<PasswordValidationLabelsType> = ({
  passwordHasError,
  passwordIsValid,
  passwordValidatorLabels,
  validPassword,
}) => {
  const labelsList =
    passwordValidatorLabels &&
    passwordValidatorLabels.map(label => {
      const validStyles = validPassword[label.validator] && styles.valid;
      const errorStyles = passwordHasError && styles.error;

      return (
        <p
          key={label.copy}
          className={`${styles.validationTxt} ${validStyles} ${errorStyles}`}
        >
          {label.copy}
        </p>
      );
    });

  return <div className={`${styles.passwordValidation}`}>{labelsList}</div>;
};

export default PasswordValidationLabels;
